module.exports = __webpack_public_path__ + "img/brand_name_illustration_card.5343587e.svg";